import { motion, useScroll, useTransform } from "framer-motion";
import { useRef } from "react";
import Footer from "../../Components/Footer/Footer";
import Header from "../Header/Header";
import {
	Phone,
	Mail,
	MapPin,
	Clock,
} from "lucide-react";

const ContactUs = () => {
	const containerRef = useRef(null);

	// Scroll progress
	const { scrollYProgress } = useScroll({
		target: containerRef,
		offset: ["start start", "end start"],
	});

	// Parallax effect
	const imageY = useTransform(scrollYProgress, [0, 1], ["0%", "40%"]);
	const contentY = useTransform(scrollYProgress, [0, 1], ["0%", "-20%"]);

	return (
		<>
			<Header />

			<div ref={containerRef} className="bg-gray-100">
				{/* 🔹 HERO IMAGE WITH PARALLAX */}
				<div className="relative h-[60vh] overflow-hidden">
					<motion.img
						src="/assets/about-us.jpg"
						alt="Contact Us"
						style={{ y: imageY }}
						className="absolute inset-0 w-full h-full object-cover"
					/>

					<div className="absolute inset-0 bg-black/40 flex items-center justify-center">
						<motion.h1
							initial={{ opacity: 0, y: 30 }}
							animate={{ opacity: 1, y: 0 }}
							transition={{ duration: 0.8 }}
							className="text-white text-4xl md:text-5xl font-bold"
						>
							Contact Us
						</motion.h1>
					</div>
				</div>

				{/* 🔹 CONTENT SECTION */}
				<motion.div
					style={{ y: contentY }}
					className="relative z-10 -mt-24 px-4 pb-20"
				>
					<div className="bg-white max-w-6xl mx-auto shadow-xl p-8 md:p-12 grid md:grid-cols-2 gap-10">

						{/* LEFT INFO */}
						<motion.div
							initial={{ opacity: 0, x: -40 }}
							whileInView={{ opacity: 1, x: 0 }}
							transition={{ duration: 0.6 }}
							viewport={{ once: true }}
						>
							<h2 className="text-3xl font-bold mb-6">
								Get in Touch
							</h2>

							<p className="text-gray-600 mb-8">
								We’re here to help and answer any question you might have.
								Feel free to reach out to us using the details below.
							</p>

							<div className="space-y-6">
								{/* Phone */}
								<div className="flex items-start gap-4">
									<Phone className="w-6 h-6 text-black mt-1" />
									<div>
										<h4 className="font-semibold text-lg">Call Us</h4>
										<p className="text-gray-600 text-sm">
											Available 24/7
										</p>
										<p className="font-medium mt-1">
											+91-9220956556
										</p>
									</div>
								</div>

								{/* Email */}
								<div className="flex items-start gap-4">
									<Mail className="w-6 h-6 text-black mt-1" />
									<div>
										<h4 className="font-semibold text-lg">Email Us</h4>
										<p className="text-gray-600 text-sm">
											We usually respond within 24 hours
										</p>
										<p className="font-medium mt-1 underline">
											support@zakkuu.com
										</p>
									</div>
								</div>

								{/* Address */}
								<div className="flex items-start gap-4">
									<MapPin className="w-6 h-6 text-black mt-1" />
									<div>
										<h4 className="font-semibold text-lg">
											Head Office
										</h4>
										<p className="text-gray-600 text-sm mt-1">
											D-233, D Block, Sector 63,<br />
											Noida, Uttar Pradesh 201309
										</p>
									</div>
								</div>
							</div>
						</motion.div>

						{/* RIGHT INFO BOX */}
						<motion.div
							initial={{ opacity: 0, x: 40 }}
							whileInView={{ opacity: 1, x: 0 }}
							transition={{ duration: 0.6 }}
							viewport={{ once: true }}
							className="bg-gray-50 rounded-xl p-8 flex flex-col justify-center"
						>
							<h3 className="text-2xl font-bold mb-6">
								Working Hours
							</h3>

							<div className="space-y-4">
								<div className="flex items-center gap-4">
									<Clock className="w-5 h-5 text-black" />
									<p className="text-gray-700">
										Monday – Friday: <span className="font-medium">9:00 – 20:00</span>
									</p>
								</div>

								<div className="flex items-center gap-4">
									<Clock className="w-5 h-5 text-black" />
									<p className="text-gray-700">
										Saturday: <span className="font-medium">11:00 – 15:00</span>
									</p>
								</div>

								<div className="flex items-center gap-4">
									<Clock className="w-5 h-5 text-black" />
									<p className="text-gray-700">
										Sunday: <span className="font-medium">Closed</span>
									</p>
								</div>
							</div>
						</motion.div>

					</div>
				</motion.div>
			</div>

			<Footer />
		</>
	);
};

export default ContactUs;
